import React from 'react';

import QuotaVendedor  from 'components/Tvendo/Sale/QuotaBPartner/Verdum/QuotaVendedor/List.js';

export default function () {
  return <QuotaVendedor  />;
}